'use client';
import { ReactElement } from 'react';

import { t } from 'i18next';
import Image from 'next/image';

import styles from './header.module.scss';
import { buildPath } from '@storefront/utils/utils';
import { Header as VeneerHeader } from '@veneer/core';

export interface HeaderProps {
  topRightArea?: ReactElement;
}

export default function Header({ topRightArea }: Readonly<HeaderProps>) {
  const logo = (
    <Image
      src={buildPath('HPLogo-blue.svg')}
      width="48"
      height="48"
      alt={t('button.hpLogo')}
      priority
    />
  );
  return (
    <VeneerHeader
      leadingArea={logo}
      trailingArea={topRightArea}
      position="sticky"
      className={styles.header}
    />
  );
}
